import styled from 'styled-components';
import { colors } from '@omilia/theme';

// eslint-disable-next-line import/prefer-default-export
export const SForm = styled.form`
  width: 100%;

  &&& {
    > :nth-child(1),
    > :nth-child(3),
    > :nth-child(4) {
      min-height: 50px;
      margin-top: 15px;

      input {
        z-index: 1;
        background-color: transparent;
      }

      input:disabled {
        background-color: unset;
      }
    }

    > :nth-child(1) {
      margin-bottom: 5px;
    }

    > :nth-child(2) {
      margin-bottom: 0px;
      height: 74px;

      label {
        margin: 0;
        color: ${colors.COLOR_GREY_800};
        font-weight: 400;
        font-size: 0.85rem;
      }

      select {
        border: 0;
        border-bottom: 1px solid ${colors.COLOR_GREY_400};
        border-radius: 0;
        padding-left: 0;
        text-indent: 0;

        &:focus {
          box-shadow: unset;
        }
      }
    }

    > :nth-child(3) {
      margin-top: 15px;
    }
  }
`;
